import { Component } from '@angular/core';
import { DataService, WorkflowContextService } from 'src/app/services';

@Component({
  selector: 'app-help-view-janus',
  standalone:false,
  templateUrl: './help-view-janus.component.html',
  styleUrl: './help-view-janus.component.scss'
})
export class HelpViewJanusComponent {
  userGuideLink: any;
  trainingSiteLink = 'https://geopermitstraining.hubs.vidyard.com/'
  contactSupportLink = '';

  constructor(
    private _dataSvc: DataService,
    private _context: WorkflowContextService
  ) {}

  ngOnInit() {
    this.userGuideLink = '';

    this._dataSvc.getUserGuideLink().subscribe(results => {
      this.userGuideLink = results;
    });

    this.contactSupportLink = this._context.contactSupportLink;
  }

}
